import {useState, useEffect} from 'react';
import {Routes, Route, Link} from 'react-router-dom'

import './list.style.css';
import Emblem from '../Emblem/emblem.component';


const List = ({filter, array}) => {
    //console.log(filter)
    return(
        <>
        <ul className="list-container">
        { array.map( (item, index) => {
                    return (
                    <li key={index} >
                        <Link to={`search/?${filter}=${item.Id}`} >
                            <div className="list-element">
                                <Emblem 
                                    alt={`${item.Name}`} 
                                    kind={filter}
                                    id={item.Id}
                                    big={false}
                                />
                                <div className="list-header">{item.Name} ({item.Count})</div>
                            </div>
                        </Link>
                    </li>
                    );
                }
                )
        }
        </ul>
        </>
    )
}

export default List;